import GraphQLClient from '../../core/adapter/graphQLClient';
import Store from '../../entity/store';
import getCurrentStoreBySession from './query/getCurrentStoreBySession';

class StoreRepository {
  private graphqlClient: GraphQLClient;

  constructor({ graphqlClient }: { graphqlClient: GraphQLClient }) {
    this.graphqlClient = graphqlClient;
  }

  public getStoreBySession(): Promise<Store> {
    return this.graphqlClient
      .query(null, getCurrentStoreBySession)
      .then(({ data }: { data: any }) => Store.fromJson(data['storeBySession']));
  }
}

export default StoreRepository;
